<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="优惠券名称" prop="couponName" >
        <a-input v-model="form.couponName" placeholder="请输入内容"  />
      </a-form-model-item>
      <a-form-model-item label="优惠券名称英语" prop="couponNameEn" >
        <a-input v-model="form.couponNameEn" placeholder="请输入内容"  />
      </a-form-model-item>
      <a-form-model-item label="优惠券名称俄语" prop="couponNameEn" >
        <a-input v-model="form.couponNameRu" placeholder="请输入内容"  />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type" >
          <a-select v-model="form.type" placeholder="请选择">
            <a-select-option :value="1">满减券</a-select-option>
            <a-select-option :value="2">立减券</a-select-option>
            <a-select-option :value="3">拉新优惠券</a-select-option>
            <a-select-option :value="4">免邮券</a-select-option>
            <a-select-option :value="5">品类券</a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item label="优惠券规则" prop="fullMoney" v-if="form.type == 1 || form.type == 3 || form.type == 5">
        满<a-input-number :min="0" v-model="form.fullMoney" placeholder="请输入" />元
        减<a-input-number :min="0" v-model="form.discountMoney" placeholder="请输入" />元
      </a-form-model-item>
      <a-form-model-item label="优惠券规则" prop="fullMoney" v-if="form.type == 2">
        立减<a-input-number :min="0" v-model="form.discountMoney" placeholder="请输入" />元
      </a-form-model-item>
      <a-form-model-item label="商品分类(多选)" prop="categoryIds" v-if="form.type == 5">
        <a-select v-model="form.categoryIds" placeholder="请选择" mode="multiple">
          <a-select-option v-for="item in categoryList" :key="item.id">
            {{ item.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="使用有效期" prop="validDuration" >
        <a-input-number :min="1" v-model="form.validDuration" placeholder="请输入" />天
      </a-form-model-item>
<!--      <a-form-model-item label="观看时长(秒)" prop="watchTime" >
        <a-input-number :min="0" v-model="form.watchTime" placeholder="请输入" />秒
      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/coupon/coupon'
import {listGoodsCategory} from "@/api/goods/goodsCategory";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      categoryList: [],
      // 表单参数
      form: {
        id: null,
        couponName: null,
        couponNameEn: null,
        couponNameRu: null,
        type: null,
        fullMoney: null,
        discountMoney: null,
        categoryIds: null,
        categoryIdList:[],
        validPeriod: null,
        createTime: null,
        remark: null,
        watchTime: null,
        validDuration: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        couponName: [
          { required: true, message: '优惠券名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型不能为空', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  activated() {
    this.initCategory()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    initCategory() {
      listGoodsCategory().then(response => {
        this.categoryList = response.data
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        couponName: null,
        couponNameEn: null,
        couponNameRu: null,
        type: null,
        fullMoney: null,
        discountMoney: null,
        categoryIds: null,
        categoryIdList:[],
        validPeriod: null,
        createTime: null,
        remark: null,
        watchTime: null,
        validDuration: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoupon({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        if(this.form.type == 5  && this.form.categoryIds){
          this.form.categoryIds = this.form.categoryIds.split(',')
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            if(this.form.type ==5  && this.form.categoryIds){
              this.form.categoryIds = this.form.categoryIds.join(',')
            }
            updateCoupon(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCoupon(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
